(() => {
  if (customElements.get('forevakaash-home')) return;
  customElements.define('forevakaash-home', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.products = [...this.querySelectorAll('[data-product]')];
      this.index = 0;
      this.grid = true;
      this.menu = this.querySelector('dialog');
      this.querySelectorAll('[data-menu-open], [data-view-toggle], [data-explore], [data-lookbook-open]').forEach(el => el.hidden = false);
      this.classList.add('fk-ready');
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-lookbook-open')) {
          const trigger = document.getElementById('lookbook-trigger');
          if (trigger) trigger.click();
        }
        if (button.hasAttribute('data-menu-open')) this.menu.showModal();
        if (button.hasAttribute('data-menu-close')) this.menu.close();
        if (button.hasAttribute('data-view-toggle')) { this.grid = !this.grid; this.render(); }
        if (button.hasAttribute('data-product-step')) {
          this.index = (this.index + Number(button.dataset.productStep) + this.products.length) % this.products.length;
          this.render();
        }
        if (button.hasAttribute('data-explore')) {
          this.index = this.products.indexOf(button.closest('[data-product]'));
          this.grid = false; this.render();
          this.querySelector('[data-view-toggle]').focus();
          this.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
        if (button.hasAttribute('data-image-step')) this.imageStep(button.closest('[data-product]'), Number(button.dataset.imageStep));
      });
      this.menu.addEventListener('close', () => this.querySelector('[data-menu-open]').focus());
      this.addEventListener('change', event => {
        if (!event.target.matches('select[name="id"]')) return;
        const option = event.target.selectedOptions[0];
        const product = event.target.closest('[data-product]');
        product.querySelector('[data-price]').textContent = option.dataset.price;
        const button = product.querySelector('button[type="submit"]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'SOLD OUT' : 'ADD TO BAG';
      });
      this.querySelectorAll('[data-stage]').forEach(stage => {
        let start;
        stage.addEventListener('touchstart', e => { start = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY }; }, { passive: true });
        stage.addEventListener('touchend', e => {
          if (!start || this.grid) return;
          const dx = e.changedTouches[0].clientX - start.x;
          const dy = e.changedTouches[0].clientY - start.y;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.imageStep(stage.closest('[data-product]'), dx < 0 ? 1 : -1);
          start = null;
        }, { passive: true });
      });
      const lookbook = document.getElementById('lookbook-dialog');
      if (lookbook) lookbook.addEventListener('close', () => this.querySelector('[data-lookbook-open]').focus());
      else this.querySelector('[data-lookbook-open]').hidden = true;
      this.render();
    }
    render() {
      this.classList.toggle('fk-grid', this.grid);
      this.products.forEach((product, i) => {
        product.hidden = !this.grid && i !== this.index;
        product.querySelectorAll('.fk-image-controls,[data-image-count]').forEach(el => el.hidden = this.grid);
        if (!product.hidden) product.querySelectorAll('img').forEach(img => img.loading = 'eager');
      });
      const toggle = this.querySelector('[data-view-toggle]');
      if (toggle) { toggle.textContent = this.grid ? 'SINGLE VIEW' : 'VIEW ALL'; toggle.setAttribute('aria-pressed', String(this.grid)); }
      const nav = this.querySelector('.fk-product-nav');
      if (nav) {
        nav.hidden = this.grid || this.products.length < 2;
        this.querySelector('[data-product-count]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.products.length).padStart(2, '0')}`;
      }
    }
    imageStep(product, step) {
      const images = [...product.querySelectorAll('[data-image]')];
      if (images.length < 2) return;
      const current = Math.max(0, images.findIndex(img => !img.hidden));
      const next = (current + step + images.length) % images.length;
      images.forEach((img, i) => img.hidden = i !== next);
      product.querySelector('[data-image-count]').textContent = `${next + 1} / ${images.length}`;
    }
  });
})();
